import apiSlice from '../api/api.slice';
import { ICreateTagBody, IGetTagsParams, ITag } from './tag';

export const createTag = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createTag: builder.mutation<ITag, ICreateTagBody>({
      query: (body) => ({
        url: `/api/v1/tag/create`,
        method: 'POST',
        body,
      }),
      transformResponse: (response: { tag: ITag }) => response.tag,
    }),
    getTags: builder.query<ITag[], IGetTagsParams>({
      query: (params) => ({
        url: `/api/v1/tag/getTags`,
        method: 'GET',
        params,
      }),
      transformResponse: (response: { tags: ITag[] }) => response.tags,
    }),
    deleteTag: builder.mutation<void, string>({
      query: (id) => ({
        url: `/api/v1/tag/delete?id=${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['Tag'],
  endpoints: {
    getTags: {
      addTagTypes: ['Tag'],
    },
    deleteTag: {
      invalidatesTags: ['Tag'],
    },
    createTag: {
      invalidatesTags: ['Tag'],
    },
  },
});

export const { useCreateTagMutation, useGetTagsQuery, useDeleteTagMutation } =
  createTag;
